/******
 *
 * Shop API
 ******/

import Request from "@/utils/Request";

export default {
  /*
  Reg No check func
  
  사업자 등록번호 중복 검사 시 사용  
   */
  checkRegNo(data) {
    return Request({
      url: "/SimpleEntry/shopCheck/" + data, //"/join/check_reg_no",
      //url: "/SimpleEntry/shopCheck/" + data, //"/join/check_reg_no",  // 사업자번호 조회가 테섭에서 안되서
      method: "get",
    });
  },
  /*
  Join In func
  
  사업자 등록 시 사용  
   */
  // joinSetup(data) {
  //   return Request({
  //     url: "/SimpleEntry/setShopInfoJoinStatus", //"/join/join_setup",
  //     method: "post",
  //     data,
  //   });
  // },

    /*
  Join In func
  
  간편입점신청시 사용 V2
   */
  setShopInfoJoinStatusV2(formData, onProgress) {
    return Request({
      url: "/SimpleEntry/setShopInfoJoinStatusV2", //"/join/join_setup",
      method: "post",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data"
      },
      onUploadProgress: e => {
      if (onProgress && e.total) {
        const percent = Math.round((e.loaded * 100) / e.total);
        onProgress(percent);
      }
    }
    });
  },
  /*
  Get Shop List func
  
  입점된 상점 가져올 때 사용  
   */
  getList(data) {
    return Request({
      url: "/join/get_list",
      method: "post",
      data,
    });
  },
};
